// extracted by mini-css-extract-plugin
module.exports = {"Wallet":"Wallet_Wallet__2MT-K","WalletTable":"Wallet_WalletTable__LFVdg","WalletRow":"Wallet_WalletRow__1ujA4"};